import React from 'react';
import { Tooltip } from './Tooltip';
import { InfoIcon } from 'lucide-react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  className?: string;
  helperText?: string;
  tooltip?: string;
  showRequiredIndicator?: boolean;
}
export function Input({
  label,
  error,
  icon,
  className = '',
  helperText,
  tooltip,
  showRequiredIndicator = true,
  ...props
}: InputProps) {
  return <div className={className} data-id="element-814">
      {label && <div className="flex items-center mb-1" data-id="element-815">
          <label htmlFor={props.id} className="block text-sm font-medium text-gray-200" data-id="element-816">
            {label}
            {props.required && showRequiredIndicator && <span className="text-red-500 ml-1" data-id="element-817">*</span>}
          </label>
          {tooltip && <Tooltip content={tooltip} position="top" data-id="element-818">
              <div className="ml-1.5 text-gray-400 hover:text-gray-300 cursor-help" data-id="element-819">
                <InfoIcon size={14} data-id="element-820" />
              </div>
            </Tooltip>}
        </div>}
      <div className="relative" data-id="element-821">
        {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400" data-id="element-822">
            {icon}
          </div>}
        <input {...props} className={`${icon ? 'pl-10' : 'pl-3'} w-full px-3 py-2 bg-gray-700 border ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-600 focus:ring-blue-500 focus:border-blue-500'} rounded-md shadow-sm focus:outline-none focus:ring-2 text-gray-200 transition-colors ${props.disabled ? 'opacity-60 cursor-not-allowed' : ''} ${props.className || ''}`} data-id="element-823" />
        {error && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-824">
            <svg className="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-825">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-826" />
            </svg>
          </div>}
      </div>
      {helperText && !error && <p className="mt-1 text-xs text-gray-400" data-id="element-827">{helperText}</p>}
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-828">{error}</p>}
    </div>;
}
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  className?: string;
  helperText?: string;
  tooltip?: string;
  showRequiredIndicator?: boolean;
}
export function Textarea({
  label,
  error,
  className = '',
  helperText,
  tooltip,
  showRequiredIndicator = true,
  ...props
}: TextareaProps) {
  return <div className={className} data-id="element-829">
      {label && <div className="flex items-center mb-1" data-id="element-830">
          <label htmlFor={props.id} className="block text-sm font-medium text-gray-200" data-id="element-831">
            {label}
            {props.required && showRequiredIndicator && <span className="text-red-500 ml-1" data-id="element-832">*</span>}
          </label>
          {tooltip && <Tooltip content={tooltip} position="top" data-id="element-833">
              <div className="ml-1.5 text-gray-400 hover:text-gray-300 cursor-help" data-id="element-834">
                <InfoIcon size={14} data-id="element-835" />
              </div>
            </Tooltip>}
        </div>}
      <textarea {...props} className={`w-full px-3 py-2 bg-gray-700 border ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-600 focus:ring-blue-500 focus:border-blue-500'} rounded-md shadow-sm focus:outline-none focus:ring-2 text-gray-200 transition-colors ${props.disabled ? 'opacity-60 cursor-not-allowed' : ''} ${props.className || ''}`} data-id="element-836" />
      {helperText && !error && <p className="mt-1 text-xs text-gray-400" data-id="element-837">{helperText}</p>}
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-838">{error}</p>}
    </div>;
}